import React, { useState } from "react";
import { CollapseArrow } from "~/assets/svg/InterfaceIcon";
import { useTranslation } from "react-i18next";

const ViewQnaCard = ({ question }) => {
	const { t } = useTranslation();
	const [openToggle, setOpenToggle] = useState(false);

	return (
		<li className={`faq-item ${openToggle ? "" : "card-close"}`}>
			<button
				type="button"
				className="faq-item-header"
				onClick={() => setOpenToggle(!openToggle)}
			>
				<CollapseArrow />
				{question.question}
			</button>
			<div className="faq-answer">
				<div className="faq-answer-badge">
					<div className="text">{t("pages.applyFormMange.viewComponent.answer")}</div>
				</div>
				{question.answer}
			</div>
		</li>
	);
};

export default ViewQnaCard;
